import { render, staticRenderFns } from "./BuyProviderComponent.vue?vue&type=template&id=6f6759ac&scoped=true"
import script from "./BuyProviderComponent.vue?vue&type=script&lang=js"
export * from "./BuyProviderComponent.vue?vue&type=script&lang=js"
import style0 from "./BuyProviderComponent.vue?vue&type=style&index=0&id=6f6759ac&prod&lang=scss&scoped=true"
import style1 from "./BuyProviderComponent.vue?vue&type=style&index=1&id=6f6759ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6759ac",
  null
  
)

export default component.exports